module.exports = __webpack_public_path__ + "3153140e55dcabe39c0e752d8fb77c4a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-24.png
// module id = 3115
// module chunks = 0